<cv-loader [hidden]="!pspos.isloadingExternalFilter"></cv-loader>
<div class="saBar" [hidden]="!(SelectionCounter > 0)">
    <div class="saContainer" *ngIf="!EnableEdit">
        <div class="saAction" (click)="SelectEdit();">
            <span class="sgEditBtn sgWhiteEditIcon"></span>
            <span class="saActionText" cvLocalizedText langSection="MarketPlace_Management"
                langKey="Edit_Action_Bar">Edit</span>
        </div>
        <div class="saAction">
            <span class="saActionText saTextCancel" (click)="SelectCancel();" cvLocalizedText
                langSection="MarketPlace_Management" langKey="Cancel">Cancel</span>
        </div>

        <div class="saCounter">
            <span>{{SelectionCounter}} <span cvLocalizedText langSection="MarketPlace_Management"
                    langKey="Items_Selected">Items Selected</span></span>
        </div>
    </div>
    <div class="saContainer" *ngIf="EnableEdit">
        <div class="saAction" (click)="SelectSave()">
            <span class="saActionText" cvLocalizedText langSection="MarketPlace_Management" langKey="Save">Save</span>
        </div>
        <div class="saAction">
            <span class="saActionText saTextCancel" (click)="SelectCancel();" cvLocalizedText
                langSection="MarketPlace_Management" langKey="Cancel">Cancel</span>
        </div>

        <div class="saCounter">
            <span>{{SelectionCounter}} <span cvLocalizedText langSection="MarketPlace_Management"
                    langKey="Items_Selected">Items Selected</span></span>
        </div>
    </div>

    <div class="saArrow"></div>
</div>

<cv-marketplace-orders-table-component class="d-block" [orders]="pspos.adminOrders"
    [search]="pspos.pointStoreProductAdminOrderFilter.searchOrder"
    [timeInterval]="pspos.pointStoreProductAdminOrderFilter.datePosition" [editable]="true"
    [status]="pspos.pointStoreProductAdminOrderFilter.SelectedStatuses" [headersNames]="pspos.groupHeaderInfo"
    (orderUpdated)="onOrderUpdated($event)" style="height: calc(100vh - 420px)"
    [MSTOffset]="pspos.MSTOffset"
    [selectGroupChange]="pspos.pointStoreProductAdminOrderFilter.groupSelectorChanged"></cv-marketplace-orders-table-component>  
